import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn
} from '@angular/forms';

export function allowSaveWithoutPaymentValidator(
  isPayment: () => boolean
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    const paymentValue: boolean = isPayment();

    if (!paymentValue) {
      return !value ? { allowSaveWithoutPayment: true } : null;
    } else {
      return null;
    }
  };
}
